import React, { Component } from 'react';
import { FormGroup, FormControl, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import history from '../history';

class ConductPraphatpongy extends Component {
  state = { recipient: 'MR.PRAPHATPHONG YOODEE', amount: 1, knownAddresses: [] };

  componentDidMount() {
    fetch(`${document.location.origin}/api/known-addresses`)
      .then(response => response.json())
      .then(json => this.setState({ knownAddresses: json }));
  }

  updateRecipient = event => {
    this.setState({ recipient: event.target.value });
  }
  updateAmount = event => {
    this.setState({ amount: Number(event.target.value) });
  }
  conductTransaction = () => {
    const { recipient, amount } = this.state;
    fetch(`${document.location.origin}/api/transact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ recipient, amount })
    }).then(response => response.json())
      .then(json => {
        alert(json.message || json.type);
        history.push('/transaction-pool');
      });
  }
  render() {
    return (
      <div className='ConductTransaction'>
        <h3>Register</h3>
        <br />
        <br />
        <FormGroup>
          <FormControl
            input='text'
            placeholder=''
            value={this.state.recipient}
            onChange={this.updateRecipient}
          />
        </FormGroup>
        <div>
          <Button
            bsStyle="danger"
            onClick={this.conductTransaction}
          >
            Submit
          </Button>
          </div>
          <br />
          <br />
          <div><Link to='/biopraphatpongy'>Member's Biography</Link></div>
          </div>
    )
  }
};
export default ConductPraphatpongy;
